import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Hide, Space, Shimmer, ShimmerTypography } from '@pitchero/react-ui';
import TableLoadingStateRow from './row';

const TableLoadingState = ({ columns, rows }) => {
  const additionalHeaderColumns = () => {
    const headerColumns = [];

    for (let i = 1; i <= columns; i += 1) {
      headerColumns.push(
        <Hide maxWidth="tab" key={i}>
          <ShimmerTypography width={24} />
        </Hide>,
      );
    }
    return headerColumns;
  };

  const renderHeaderRow = () => (
    <>
      <ShimmerTypography preset="tag--small" />
      <ShimmerTypography preset="tag--small" />
      <div />
      {additionalHeaderColumns()}
    </>
  );

  const renderRows = () => {
    const placeholderRows = [];

    for (let i = 1; i <= rows; i += 1) {
      placeholderRows.push(<TableLoadingStateRow preset="tag--small" key={i} columns={columns} />);
    }

    return placeholderRows;
  };

  return (
    <Space bottom="xxlarge" component="div">
      <Space bottom="medium" component="div">
        <Grid
          columns="1fr 1fr"
          columnGap="xlarge"
          rowGap="small"
          responsive={[{ maxWidth: 'palm', props: { columns: '1fr' } }]}
        >
          <Shimmer preset="title" height="44px" radius="22px" />
          <Shimmer preset="title" height="44px" radius="22px" />
        </Grid>
      </Space>
      <Space horizontal="large" component="div">
        <Grid
          columns={`24px 36px 1fr repeat(${columns}, 24px)`}
          columnGap="medium"
          rowGap="medium"
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          responsive={[{ maxWidth: 'tab', props: { columns: '24px 36px 1fr' } }]}
        >
          {renderHeaderRow()}
          {renderRows()}
        </Grid>
      </Space>
    </Space>
  );
};

TableLoadingState.defaultProps = {
  columns: 14,
  rows: 10,
};

TableLoadingState.propTypes = {
  columns: PropTypes.number,
  rows: PropTypes.number,
};

export default TableLoadingState;
